import axios from 'axios';
import config from 'commons-vehicle/config/index.js';

import { HTTPService, ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';

class ShowroomAPIService {
    constructor() {
        this.basePath = `${config.endpoint.showroom}/service/v1`;
    }

    getPublicToken() {
        return axios.get(`${this.basePath}/jwt?userName=public&password=public`);
    }

    saveQuote(quote, token, quoteContext) {
        if (!quote || !token) {
            return Promise.reject(HTTPService.formatRejectResponse('missing parameters'));
        }

        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const location = ConfigsService.getOrganizationUnitLocation().toLowerCase();
        const locale = LocaleService.getLocale();

        let context = `refresh=1&location=${location}&datalevel=1&context=${orgId}.${orgUnitId}&language=${locale}`;

        if (quote.securityToken) {
            context += `&securityToken=${quote.securityToken}`;
        }

        if (quoteContext) {
            context += `&${quoteContext}`;
        }

        return axios.put(`${this.basePath}/Quote?${context}`, quote, { headers: { 'x-jwt': token } }).then((result) => {
            return Promise.resolve(result.data);
        });
    }
}

export default new ShowroomAPIService();



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/services/ShowroomService/ShowroomAPIService.js